import { CurrentSubscriptionsOptions, SubscriptionItem, OptionItem, RetentionOfferResponse } from "../../types/rtk/currentSubscriptionsOptions/currentSubscriptionsOptions";
import { apiSlice } from "../_api/api-slice";
import mockCurrentSubscriptionsOptions from "./mockCurrentSubscriptionsOptions.json";

const USE_MOCK = false;

const currentSubscriptionsOptionsEndpoint = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    getCurrentSubscriptionsOptions: build.query<CurrentSubscriptionsOptions, void>({
      ...(USE_MOCK
        ? {
            queryFn: async () => {
              await new Promise((resolve) => setTimeout(resolve, 500));
              return {
                data: mockCurrentSubscriptionsOptions as CurrentSubscriptionsOptions
              };
            },
          }
        : {
            query: () => ({
              url: `/tracker/subscriptions`,
              method: "get",
            }),
          }),
      providesTags: ['SubscriptionOptions'],
    }),
    editOption: build.mutation<OptionItem, { option_code: string; renewal_active: boolean, cancel_reason?: string, cancel_explanation?: string }>({
      query: (body) => ({
        url: `/tracker/option`,
        method: "POST",
        body,
      }),
      invalidatesTags: ['SubscriptionOptions'],
    }),
    editSubscription: build.mutation<SubscriptionItem, { renewal_active: boolean, cancel_reason?: string, cancel_explanation?: string }>({
      query: (body) => ({
        url: `/tracker/subscription`,
        method: "POST",
        body,
      }),
      invalidatesTags: ['SubscriptionOptions'],
    }),
    changeSubscriptionOffer: build.mutation<SubscriptionItem, { period : number }>({
      query: (body) => ({
        url: `/tracker/change-offer`,
        method: "POST",
        body,
      }),
      invalidatesTags: ['SubscriptionOptions'],
    }),
    getRetentionOffers: build.query<RetentionOfferResponse, { cancel_reason: string }>({
      query: (params) => ({
        url: `/tracker/retention/offers`,
        method: "GET",
        params,
      })
    }),
    acceptRetentionOffer: build.mutation<SubscriptionItem, { retention_offer_id: number; cancel_explanation?: string }>({
      query: (body) => ({
        url: `/tracker/retention/offers/accept`,
        method: "POST",
        body,
      }),
      invalidatesTags: ['SubscriptionOptions'],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetCurrentSubscriptionsOptionsQuery,
  useEditOptionMutation,
  useEditSubscriptionMutation,
  useChangeSubscriptionOfferMutation,
  useLazyGetRetentionOffersQuery,
  useAcceptRetentionOfferMutation,
} = currentSubscriptionsOptionsEndpoint;